export const COUNTRY_CODE_ENUM = {
  FR: 'FR',
  BE: 'BE',
  NL: 'NL',
  DE: 'DE',
  UK: 'UK',
  AU: 'AU',
  NZ: 'NZ',
  US: 'US',
  CA: 'CA',
  MX: 'MX',
}

export const getDefaultSpySettingByCountry = countryCode => {
  const defaultSettings = {
    hourlyRate: '11',
    maxBudgetPerWeek: '0',
    travelAllowancePerMission: '0',
    travelAllowanceCap: '20',
    durationHandToHandMission: '15',
    durationLetterboxMission: '15',
    durationShift: '3',
    missionsPerShift: '3',
  }

  switch (countryCode) {
    case COUNTRY_CODE_ENUM.FR:
      defaultSettings.hourlyRate = '11'
      break
    case COUNTRY_CODE_ENUM.BE:
      defaultSettings.hourlyRate = '11'
      break
    case COUNTRY_CODE_ENUM.NL:
      defaultSettings.hourlyRate = '11'
      break
    case COUNTRY_CODE_ENUM.DE:
      defaultSettings.hourlyRate = '11'
      break
    case COUNTRY_CODE_ENUM.UK:
      defaultSettings.hourlyRate = '10'
      break
    case COUNTRY_CODE_ENUM.AU:
      defaultSettings.hourlyRate = '20'
      break
    case COUNTRY_CODE_ENUM.NZ:
      defaultSettings.hourlyRate = '20'
      break
    case COUNTRY_CODE_ENUM.US:
      defaultSettings.hourlyRate = '20'
      break
    case COUNTRY_CODE_ENUM.CA:
      defaultSettings.hourlyRate = '20'
      break
    case COUNTRY_CODE_ENUM.MX:
      defaultSettings.hourlyRate = '67'
      break
  }

  return defaultSettings
}

export const DEFAULT_DATA = {
  h2hCheckInTimeBefore: 30,
  h2hCheckInTimeAfter: 30,
  d2dCheckInTimeBefore: 30,
  d2dCheckInTimeAfter: 30,
  h2hBonusCheckInTimeBefore: 30,
  h2hBonusCheckInTimeAfter: 15,
  d2dBonusCheckInTimeBefore: 30,
  d2dBonusCheckInTimeAfter: 15,
}

export const FRANCE_DATA = {
  h2hCheckInTimeBefore: 20,
  h2hCheckInTimeAfter: 30,
  d2dCheckInTimeBefore: 20,
  d2dCheckInTimeAfter: 30,
  h2hBonusCheckInTimeBefore: 20,
  h2hBonusCheckInTimeAfter: 20,
  d2dBonusCheckInTimeBefore: 20,
  d2dBonusCheckInTimeAfter: 20,
}

export const FRANCE_COUNTRY_ID = '7'
